import { PagesAction, PagesActionType } from './action-types';
import { IPagesState } from './types';

export const pagesReducerName = 'PagesReducer';

export const pagesInitialState: IPagesState = {
  pages: [],
  folders: []
};

export function pagesReducer(prev: IPagesState = pagesInitialState, action: PagesAction): IPagesState {
  switch (action.type) {
    case PagesActionType.ADD_PAGE:
      if (!prev.pages.find(page => page.name == action.page.name)) {
        return {
          ...prev,
          pages: [...prev.pages, action.page]
        };
      }
      else {
        prev.pages.map(page => {
          if (page.name == action.page.name) {
            prev.pages[prev.pages.indexOf(page)] = action.page
          }
        })
        return prev;
      }

    case PagesActionType.REMOVE_PAGE:
      prev.pages.map(page => {
        if (page.name == action.page.name) {
          prev.pages[prev.pages.indexOf(page)] = null;
        }
      })
      return prev;

    case PagesActionType.ADD_FOLDER:
      if (!prev.folders.find(folder => folder.name == action.folder.name)) {
        return {
          ...prev,
          folders: [...prev.folders, action.folder]
        };
      }
      else {
        prev.folders.map(folder => {
          if (folder.name == action.folder.name) {
            prev.folders[prev.folders.indexOf(folder)] = action.folder
          }
        })
        return prev;
      }

    default:
      return prev;
  }
}